"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const a=require("./index52.js");var e=a.global,l=e;exports.path=l;
